import { render, staticRenderFns } from "./_notification.vue?vue&type=template&id=78e33290&scoped=true&lang=pug&"
import script from "./_notification.vue?vue&type=script&lang=js&"
export * from "./_notification.vue?vue&type=script&lang=js&"
import style0 from "./_notification.vue?vue&type=style&index=0&id=78e33290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e33290",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
